import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const resendOrderEmailReducer = createReducer<State, Actions>(initialState, {
  [actions.resendOrderEmail.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.resendOrderEmail.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.resendOrderEmail.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.resendOrderEmail.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default resendOrderEmailReducer;
